// extracted by mini-css-extract-plugin
export default {"container":"SubirDocumentosTable_container__NG1kF","link":"SubirDocumentosTable_link__g367B","marginBottom":"SubirDocumentosTable_marginBottom__9BI9H"};